import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import swal from "sweetalert";
import logo from './../../../assets/img/logo.png';

const Footer = (props) => {
      const [email, setEmail] = useState("");
    
      const handleSubscribe = (e) => {
        e.preventDefault();
    
        // Send email to backend
        axios.post("/api/newsletter-subscribe", { email })
          .then(res => {
            if (res.data.status === 200) {
              swal("Success", res.data.message, "success");
              setEmail("");
            } else {
              swal("Error", res.data.message, "error");
            }
          })
          .catch(err => {
            swal("Error", "Something went wrong.", "error");
          });
      };

  return (
    <footer className="footer-area clearfix">
        <div className="top-footer-area section_padding_100_0">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-sm-6 col-lg-3">
                        <div className="single-footer-widget mb-50">
                            <Link to="/" className="mb-50 d-block">
                                <img src={logo} title="MIPAT" alt="MIPAT" className="logo" /> 

                                <div style={{ lineHeight: '85%', color: '#066638' }}>
                                  <h5>Modern Integrated Farms and Food Processing Ltd</h5>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-3">
                        <div className="single-footer-widget mb-50">
                            <h5>Quick Links</h5>
                            <Link to="/"><p className="green-links">Home</p></Link>
                            <Link to="/about"><p className="green-links">About Us</p></Link>
                            <Link to="/products"><p className="green-links">Our Products</p></Link>
                            <Link to="/contact"><p className="green-links">Contact</p></Link>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-3">
                        <div className="single-footer-widget mb-50">
                            <h5>Products</h5>
                        
                            <Link to="/products/spillclean-powder">
                                <p className="green-links">SpillClean Powder</p>
                            </Link>

                            <Link to="/products/fertilizer-and-water-mixing-machine">
                                <p className="green-links">Fertilizer and Water Mixing Machine</p>
                            </Link>

                            <Link to="/products/cocopeat-and-coconut-husk-chips">
                                <p className="green-links">Cocopeat and Coconut Husk Chips</p>
                            </Link>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-3">
                        <div className="single-footer-widget mb-50">
                            <h5>Contact Info</h5>
                            <div className="footer-single-contact-info text-danger">
                                <p style={{ color: '#ddd' }}>No. 3, G Close 3rd Avenue, Gowon Estate, Ipaja New layout, Alimosho LGA, 
                                    <br />Lagos State, Nigeria.</p>

                                <br />
                                <p style={{ color: '#ddd' }}><i className="fa fa-phone"></i> <i className="fa fa-whatsapp"></i> +234 903 814 8585 
                                    <br /><i className="fa fa-phone"></i> +234 907 742 2961</p>
                                <p style={{ color: '#ddd' }}><i className="fa fa-envelope"></i> mipatfarms@gmail.com</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div className="footer-bottom-area">
            <div className="container h-100">
                <div className="row h-100">
                    <div className="col-12 h-100">
                        <div className="footer-bottom-content h-100 d-md-flex justify-content-between align-items-center">
                            <div className="copyright-text">
                                <p style={{ color: '#ddd' }}>&copy; <script>document.write(new Date().getFullYear());</script> All rights reserved. By <a href="" target="_blank">Web Engineer</a>
                                </p>
                            </div>
                            {/* <div className="footer-social-info">
                                <a href="#"><i className="fa fa-pinterest" aria-hidden="true"></i></a>
                                <a href="#"><i className="fa fa-facebook" aria-hidden="true"></i></a>
                                <a href="#"><i className="fa fa-twitter" aria-hidden="true"></i></a>
                                <a href="#"><i className="fa fa-dribbble" aria-hidden="true"></i></a>
                                <a href="#"><i className="fa fa-behance" aria-hidden="true"></i></a>
                                <a href="#"><i className="fa fa-linkedin" aria-hidden="true"></i></a>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
  )
}
export default Footer;